import React from 'react';
import SEO from '@/SEO';

const HTML_CONTENT = `<h1>வைதிக அடிப்படை</h1>
  <h1>பொதுவாக அறியவேண்டியவை</h1>
  <div class="half">
    <!--Accordion Start-->
    <div class="mydiv">
      இங்கே கச்சம் அணிவது எப்படி என விளக்கி ஒரு
      gif (இன்டர்நெட் தேவையில்லை) ஒன்றும், வீடியோ
      ஒன்றும் வழங்கப்பட்டுள்ளது. <hr>
      ப்ரஹ்மசாரியானால் ஒரு வஸ்த்ரமும்,
      க்ருஹஸ்தர்களானால் இரு வஸ்த்ரமும் கட்டாயம்
      எப்போதும் இருக்கவேண்டும். <hr>
      மூன்றாவது வஸ்த்ரம் (த்ருதீய வஸ்த்ரம்) ஒன்று
      இருந்தால், மேனியின் மேல் பகுதியைப் போற்றிக்கொள்ள,
      காயத்ரி ஜபம் போன்ற காலங்களில் உபயோகமாக இருக்கும்.
      கடி ஸூத்ரம் எனும் அரைஞாண் கயிறு அவசியம்.
    </div>
    <ion-item>
      <div class="video-container">

          <iframe src="https://www.youtube.com/embed/rOL27DwPHSs?rel=0" frameborder="0" width="300" height="169"></iframe>
      </div>
      </ion-item>
    <div class="tab">
      <input id="tab01" type="radio" name="tabs2">
      <label for="tab01">கச்சம் அணிவது எப்படி?</label>
      <div class="tab-content">

<img src="assets/img/vasthra-dharanam.gif" style="width:100%;">
<hr>
<ion-item>
    <div class="video-container">
        <iframe src="https://www.youtube.com/embed/LkhCY4VO6j0?rel=0" frameborder="0" width="300" height="169"></iframe>
        </div>
    </ion-item>

      </div>
    </div>
    <div class="tab">
      <input id="tab02" type="radio" name="tabs2">
      <label for="tab02">திருமண் காப்பு தரித்தல்</label>
      <div class="tab-content">
        <div class="hint">
          சுத்தமான இடத்தில், சிறிது ஜலம் ப்ரோக்ஷித்து, கிழக்குப் பார்க்க சம்மணமிட்டு அமர்ந்துகொண்டு, கீழ்க்கண்ட வரிசையில் திருமண் மற்றும்
          ஸ்ரீசூர்ணத்தை குழைத்து அந்தந்த மந்திரத்துடன் இட்டுக்கொள்ளவும்.

        </div>
        <div class="mydiv">
            <h2>திருமண் தரிக்கும் க்ரமம்</h2>
        </div>
        <img src="assets/img/thiruman-kaappu.jpg">
        <br>
        <div class="prayogam">

            <ion-grid>
                <ion-row>
                  <ion-col col-4>
                      1. நெற்றி
                  </ion-col>
                  <ion-col>
                      கேஸவாய நம:
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col col-4>
                      2. நடு வயிறு
                  </ion-col>
                  <ion-col>
                      நாராயணாய நம:
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col col-4>
                      3. மார்பு
                  </ion-col>
                  <ion-col>
                      மாதவாய நம:
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col col-4>
                      4. நடு கழுத்து
                  </ion-col>
                  <ion-col>
                      கோவிந்தாய நம:
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col col-4>
                      5. வலது வயிறு
                  </ion-col>
                  <ion-col>
                      விஷ்ணவே நம:
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col col-4>
                      6. வலது புஜம்
                  </ion-col>
                  <ion-col>
                      மதுசூதனாய நம:
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col col-4>
                      7. வலக் கழுத்து
                  </ion-col>
                  <ion-col>
                      திரிவிக்ரமாய நம:
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col col-4>
                      8. இடது வயிறு
                  </ion-col>
                  <ion-col>
                      வாமனாய நம:
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col col-4>
                      9. இடது புஜம்
                  </ion-col>
                  <ion-col>
                      ஸ்ரீதராய நம:
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col col-4>
                      10. இடக் கழுத்து
                  </ion-col>
                  <ion-col>
                      ருஷிகேஸாய நம:
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col col-4>
                      11. அடி முதுகு
                  </ion-col>
                  <ion-col>
                      பத்மநாபாய நம:
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col col-4>
                      12. பின் கழுத்து
                  </ion-col>
                  <ion-col>
                      தாமோதராய நம:
                  </ion-col>
                </ion-row>
              </ion-grid>
          இடது கையில் மீதம் உள்ள திருமண்ணை,
          வாசுதேவாய நம: என்று உச்சந்தலையில்
          தடவிக்கொள்ளவேண்டும்.
        </div>
        <hr>
        <div class="mydiv">
        <h2>ஸ்ரீசூர்ணம் தரிக்கும் க்ரமம்</h2></div>
        <img src="assets/img/srichurnam-final.jpg">

        <div class="prayogam">
            <ion-grid>
                <ion-row>
                  <ion-col col-4>
                      1. நெற்றி
                  </ion-col>
                  <ion-col>
                      ஸ்ரீயை நம:
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col col-4>
                      2. நடு வயிறு
                  </ion-col>
                  <ion-col>
                      அம்ருதோத் பவாயை நம:
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col col-4>
                      3. மார்பு
                  </ion-col>
                  <ion-col>
                      கமலாயை நம:
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col col-4>
                      4. நடு கழுத்து
                  </ion-col>
                  <ion-col>
                      சந்த்ரசோதர்யை நம:
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col col-4>
                      5. வலது வயிறு
                  </ion-col>
                  <ion-col>
                      விஷ்ணுபத்ந்யை நம:
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col col-4>
                      6. வலது புஜம்
                  </ion-col>
                  <ion-col>
                      வைஷ்ணவ்யை நம:
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col col-4>
                      7. வலக் கழுத்து
                  </ion-col>
                  <ion-col>
                      வராரோஹாயை நம:
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col col-4>
                      8. இடது வயிறு
                  </ion-col>
                  <ion-col>
                      ஹரிவல்லபாயை நம:
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col col-4>
                      9. இடது புஜம்
                  </ion-col>
                  <ion-col>
                      சார்ங்கிண்யை நம:
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col col-4>
                      10. இடக் கழுத்து
                  </ion-col>
                  <ion-col>
                      தேவதேவிகாயை நம:
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col col-4>
                      11. அடி முதுகு
                  </ion-col>
                  <ion-col>
                      மஹாலக்ஷ்ம்யை நம:
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col col-4>
                      12. பின் கழுத்து
                  </ion-col>
                  <ion-col>
                      சுரசுந்தர்யை நம:
                  </ion-col>
                </ion-row>
              </ion-grid>

           இடது கையில் மீதம் உள்ள ஸ்ரீசூர்ணத்தை
           ஸர்வாபீஷ்ட பலப்ரதாயை நம: என்று
           உச்சந்தலையில் தடவிக்கொள்ளவேண்டும்.</div>

      </div>
    </div>
    <div class="tab">
      <input id="tab03" type="radio" name="tabs2">
      <label for="tab03">அபிவாதி பட்டியல்</label>
      <div class="tab-content">
        <h1>Abhivadhi List</h1>
        <div class="mydiv">
          <div class="prayogam">
            If you know the name of the Rushis of your gothram, then it is very easy to recite the Abhivathi with the common format of
            abhivathi as below:</div>
        </div>

        <div class="head2">For 3 Rushi - Yajur-Apastamba</div>
        <div class="mydiv">
          <div class="prayogam"> Abhivadhaye .....(Rushi1), ..... (Rushi2), ....... (Rushi3) thraiyarusheya pravaraanvita ........ (your gothram)
            gothra: Apastamba Sootra: Yajur shaakhaa adhyaayee ....... .... (your sharma) naamaaham asmibhoho.

          </div>
          <hr class="new">
          <div class="english">
            For five rushi gothrams like Srivatsa gothram: <br>
            only the "thrayarusheya" to be replaced with : "pancharusheya"<br>
            for 7 rushi gothram like Sandilya gothram: <br>
            that should be replaced with : "sapthaarusheya".
          </div>
        </div>
        <div class="svk2">
          <ion-grid>
            <ion-row>
              <ion-col> Gothram</ion-col>

              <ion-col> Rishis</ion-col>
            </ion-row>
            <ion-row>
              <ion-col>Arthreya</ion-col>

              <ion-col>Arthreya Archananasa Chyavaasva
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>Kasyapa</ion-col>

              <ion-col>Kasyapa Aavathsara Saandilya
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>Koundinya</ion-col>

              <ion-col>Vaasishta Maithravaruna Koundinya
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>Kousiga</ion-col>

              <ion-col>Vaisvamithra Agamarshana Kousiga
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>Gargeya</ion-col>

              <ion-col>Angirasa Sainya Gargeya
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>Bharatwaja</ion-col>
              <ion-col>Angirasa Barhaspathya Baratwaja
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>Nithruva kasyapa</ion-col>

              <ion-col>Kasyapa Aavathsara Nithruva
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>Vaathula</ion-col>

              <ion-col>Bhargava Vaithahavya Saavedhasa
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>Shadamarshana</ion-col>

              <ion-col>Angirasa Thrasathasya Pourukuthsa
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>Haritha</ion-col>

              <ion-col>Angirasa Ambarisha Yownachva
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>Viswamithra</ion-col>

              <ion-col>Visvamithra Dhevaradha Audhala
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>Mouthgalya</ion-col>

              <ion-col>Angirasa Baramyasva Mouthgalya
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>Sankruthi</ion-col>

              <ion-col>Saathya Gowraveetha Sankruthya
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>Kuthsa</ion-col>

              <ion-col>Angirasa Mandhathra Kouthsa
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>Kanva</ion-col>

              <ion-col>Angirasa Ajameeda Kanva
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>Parasara</ion-col>

              <ion-col>Vasishta Saakthya Parasarya
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>Badharayana</ion-col>

              <ion-col>Angirasa Barshadhasva Raadeethara
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>Agasthya</ion-col>

              <ion-col>Agasthya Thartyachudha Sowmavaha
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>Srivathsa</ion-col>

              <ion-col>Bhargava Chyavana Apnavana Aurva Jamadhaknya
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>Saandilya</ion-col>

              <ion-col>Kasyapa Aavathsara Nithruva Repa Raipa Soundilya Saandilya
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>
      </div>

    </div>

  </div>
  <!--Accordion End-->
  <h2>பெருமாள் திருவாராதனம்</h2>
  <div class="prayogam">
    நித்யகர்மாவில் பெருமாள் திருவாராதனமும் ஒரு அங்கம் ஆகும். எனவே,
    காலை ஸந்தியாவந்தனம் ஆனபிறகு, மடியாக இருந்தால், இங்கே கீழே தரப்பட்டுள்ள
    வீடியோவை அநுசரித்து, முடிந்த அளவுக்கு ஆராதனம் பண்ணவும்.
    இந்த வீடியோவில் உள்ளதுபோல் செய்தாலே க்ருஹஸ்தர்களுக்குப் போதுமானதாக இருக்கும்.

  </div>
  <hr>
  <ion-item>
      <div class="video-container">

          <iframe width="300" height="169" src="https://www.youtube.com/embed/LCntsaVcbtY?rel=0" frameborder="0"></iframe>
          </div>
      </ion-item>`;

const VaideekaBasicsPage = () => {
  return (
    <div className="vaideekam-page-container w-full max-w-4xl mx-auto p-4 md:p-6 pb-24">
      <SEO title="Vaideeka Basics  - Ahobilam" />
      <div 
        className="vaideekam-content bg-white p-6 rounded-xl shadow-sm border border-green-100/50"
        dangerouslySetInnerHTML={{ __html: HTML_CONTENT }} 
      />
    </div>
  );
};

export default VaideekaBasicsPage;
